import React from 'react';
import * as Sentry from '@sentry/browser';

export default class ErrorBoundary extends React.Component {
  state = { hasError: false }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    Sentry.captureException(error);
  }

  render() {
    if (this.state.hasError) {
      const { carrier_tracking_url } = this.props.data;

      if (carrier_tracking_url) {
        window.location = carrier_tracking_url;
        return null;
      }

      return (
        <p>
          An unexpected error occurred. Please contact your merchant for help.
        </p>
      );
    }

    return this.props.children;
  }
}
